import { FlexGrow, Footer } from './styles';
import { AuthLayoutFooterProps } from './types';

const AuthLayoutFooter = ({ children }: AuthLayoutFooterProps) => {
  return (
    <>
      <FlexGrow key="space" />

      <Footer key="footer">{children}</Footer>
    </>
  );
};
export default AuthLayoutFooter;
